import { SVG } from '../SVG'

export const ElectorsList = ({ inactive = false, style = {}, ...props }) => {
  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' style={{ ...style }} {...props}>
      <path
        d='M7.5 18.75C9.15685 18.75 10.5 17.4069 10.5 15.75C10.5 14.0931 9.15685 12.75 7.5 12.75C5.84315 12.75 4.5 14.0931 4.5 15.75C4.5 17.4069 5.84315 18.75 7.5 18.75Z'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3 21C3.52395 20.3014 4.20336 19.7344 4.98442 19.3438C5.76549 18.9533 6.62675 18.75 7.5 18.75C8.37325 18.75 9.23451 18.9533 10.0156 19.3438C10.7966 19.7344 11.476 20.3014 12 21'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.5 9C9.15685 9 10.5 7.65685 10.5 6C10.5 4.34315 9.15685 3 7.5 3C5.84315 3 4.5 4.34315 4.5 6C4.5 7.65685 5.84315 9 7.5 9Z'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3 11.25C3.52395 10.5514 4.20336 9.98438 4.98442 9.59385C5.76549 9.20332 6.62675 9 7.5 9C8.37325 9 9.23451 9.20332 10.0156 9.59385C10.7966 9.98438 11.476 10.5514 12 11.25'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.5 18.75C18.1569 18.75 19.5 17.4069 19.5 15.75C19.5 14.0931 18.1569 12.75 16.5 12.75C14.8431 12.75 13.5 14.0931 13.5 15.75C13.5 17.4069 14.8431 18.75 16.5 18.75Z'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 21C12.524 20.3014 13.2034 19.7344 13.9844 19.3438C14.7655 18.9533 15.6267 18.75 16.5 18.75C17.3733 18.75 18.2345 18.9533 19.0156 19.3438C19.7966 19.7344 20.476 20.3014 21 21'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.5 9C18.1569 9 19.5 7.65685 19.5 6C19.5 4.34315 18.1569 3 16.5 3C14.8431 3 13.5 4.34315 13.5 6C13.5 7.65685 14.8431 9 16.5 9Z'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 11.25C12.524 10.5514 13.2034 9.98438 13.9844 9.59385C14.7655 9.20332 15.6267 9 16.5 9C17.3733 9 18.2345 9.20332 19.0156 9.59385C19.7966 9.98438 20.476 10.5514 21 11.25'
        fill='none'
        stroke={inactive ? 'var(--color-white)' : 'var(--primary-color)'}
        strokeWidth={1}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SVG>
  )
}
